const CarouselStyles = {
    container: {
        alignItems: 'center',
        borderRadius: '8px',
        background: 'linear-gradient(89deg, #337dc9 0.79%, #004a96 50.49%)',
        boxShadow: '0px 2px 24px 8px rgba(0, 92, 188, 0.12)',
        display: 'flex',
        padding: '32px 48px',
        gap: '32px',
        justifyContent: 'start',
        flexWrap: 'wrap',
        '@media (max-width: 991px)': {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    },
    Content: {
        container: {
            alignSelf: 'stretch',
            display: 'flex',
            minWidth: '240px',
            marginTop: 'auto',
            marginBottom: 'auto',
            flexDirection: 'column',
            alignItems: 'stretch',
            fontFamily: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
            fontWeight: 700,
            justifyContent: 'center',
            flex: 1,
            flexShrink: 1,
            flexBasis: '0%',
        },
        header: {
            alignSelf: 'stretch',
            width: '100%',
            gap: '10px',
            fontSize: '16px',
            textTransform: 'uppercase',
            lineHeight: 1,
        },
        heading: {
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '40px',
            lineHeight: 1.4,
            marginTop: '4px',
        },
        description: {
            color: '#efefef',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '28px',
            marginTop: '4px',
        },
        tagsContainer: {
            display: 'flex',
            marginTop: '16px',
            width: '100%',
            alignItems: 'start',
            gap: '8px',
            fontSize: '12px',
            color: '#000',
            fontWeight: 400,
            justifyContent: 'start',
            flexWrap: 'wrap',
        },
    },
    Image: {
        container: {
            alignSelf: 'stretch',
            display: 'flex',
            minWidth: '240px',
            marginTop: 'auto',
            marginBottom: 'auto',
            flexDirection: 'column',
            overflow: 'hidden',
            alignItems: 'center', // Center image horizontally
            justifyContent: 'center',
            width: '395px',
            margin: 0, // Remove default figure margin
            padding: 0, // Remove default figure padding
        },
        image: {
            aspectRatio: '1.32',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '100%', // Make image fill container width
            height: '100%', // Make image fill container height
            maxWidth: '100%',
            maxHeight: '100%',
            display: 'block', // Remove inline gap
        },
    },
    Tag: {
        container: {
            fontFeatureSettings: '"liga" off, "clig" off',
            alignSelf: 'stretch',
            lineHeight: '18px',
            borderRadius: '4px',
            backgroundColor: 'rgba(204, 234, 246, 1)',
            minHeight: '24px',
            padding: '3px 8px',
            gap: '2px',
            overflow: 'hidden',
            fontFamily: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
            fontWeight: 400,
            fontSize: '12px',
            color: '#000',
        },
    },
    ExploreButton: {
        button: {
            borderRadius: '24px',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            alignSelf: 'start',
            display: 'flex',
            marginTop: '16px',
            minHeight: '40px',
            flexDirection: 'column',
            overflow: 'hidden',
            alignItems: 'center',
            fontSize: '16px',
            color: '#005cbc',
            lineHeight: 1,
            justifyContent: 'center',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
            fontWeight: 700,
            padding: 0,
            '&:hover': {
                borderRadius: '24px',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                alignSelf: 'start',
                display: 'flex',
                marginTop: '16px',
                minHeight: '40px',
                flexDirection: 'column',
                overflow: 'hidden',
                alignItems: 'center',
                fontSize: '16px',
                color: '#005cbc',
                lineHeight: 1,
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
                fontWeight: 700,
                padding: 0,
            },
        },
        content: {
            display: 'flex',
            padding: '8px 24px',
            alignItems: 'center',
            gap: '8px',
            overflow: 'hidden',
            justifyContent: 'center',
            flex: 1,
            height: '100%',
            '@media (max-width: 991px)': {
                paddingLeft: '20px',
                paddingRight: '20px',
            },
        },
        icon: {
            aspectRatio: '1',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '24px',
            alignSelf: 'stretch',
            marginTop: 'auto',
            marginBottom: 'auto',
            flexShrink: 0,
        },
        text: {
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            textOverflow: 'ellipsis',
            alignSelf: 'stretch',
            marginTop: 'auto',
            marginBottom: 'auto',
        },
    },
};

export default CarouselStyles;
